<p-dialog
  [(visible)]="display"
  header="{{ 'label.Cv-Database' | translate }}"
  (onHide)="onHide()"
  appendTo="body"
  modal="true"
  width="430"
>
  <div style="margin-bottom: 150px">
    <div>
      <p>{{ 'label.Product' | translate }}</p>
      <select
        [ngModel]="items && selectedItem"
        (ngModelChange)="items && (selectedItem = $event)"
      >
        <option *ngFor="let item of items" [ngValue]="item?.itemId">
          {{ item?.product?.name }}
        </option>
      </select>
    </div>
    <p style="color: red">{{ innerMsg }}</p>
  </div>
  <ng-template #footer>
    <p-button
      type="button"
      (click)="onSave()"
      label="{{ 'label.Save' | translate }}"
    ></p-button>
    <p-button
      type="button"
      (click)="onCancel()"
      label="{{ 'label.Cancel' | translate }}"
    ></p-button>
  </ng-template>
</p-dialog>
